import { ComponentProps } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { AudienceTray } from '../audience-tray/audience-tray';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = Omit<ComponentProps<typeof AudienceTray.SharedFooter>, 'children'>;

export const SegmentsViewFooter = (props: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix, closeTray } = useAudienceTray();

  return (
    <AudienceTray.SharedFooter {...props}>
      <Button
        variant='secondary'
        size='large'
        onClick={closeTray}
        trackingId={`${trackingIdPrefix}-segments-close-btn`}
      >
        {t('Close')}
      </Button>
    </AudienceTray.SharedFooter>
  );
};
